import { useParams } from "react-router-dom";
import styled from "styled-components";
import NavItemSmallScreen from "../MainNavigationSmallScreen/NavItemSmallScreen";
import { NavElement } from "type/navigation/main_navigation.type";
import { DlGroupSlug } from "constant/dl_group/dl_group.constant";
import {
  DL_GROUP_DESCRIPTION,
  DlGroupDescription,
} from "constant/dl_group/dl_group_description.constant";

type GroupNavigationMobProps = {
  clickHandle: () => void;
};

type NavItemProps = {
  navItem: NavElement;
};

const GroupNavigationMob = ({ clickHandle }: GroupNavigationMobProps) => {
  const { slug } = useParams<{ slug: string }>();

  const gSlug = slug as DlGroupSlug;
  if (!gSlug || !DL_GROUP_DESCRIPTION[gSlug]) return null;

  const NavItem = ({ navItem }: NavItemProps) => {
    return <NavItemSmallScreen navItem={navItem} clickHandle={clickHandle} />;
  };

  const group: DlGroupDescription = DL_GROUP_DESCRIPTION[gSlug];

  return (
    <Wrapper>
      <NavItem navItem={{ path: `/g/${gSlug}`, title: group.linkLabelMob }} />
      <NavItem
        navItem={{ path: `/g/${gSlug}/kd`, title: "izložbeni katalozi" }}
      />
      <NavItem navItem={{ path: `/g/${gSlug}/d`, title: "knjige" }} />
      <NavItem navItem={{ path: `/g/${gSlug}/p`, title: "periodika" }} />
      <NavItem navItem={{ path: `/g/${gSlug}/hm`, title: "hemeroteka" }} />
      <NavItem
        navItem={{
          path: `/g/${gSlug}/photo-series/ph`,
          title: "fotodokumentacija",
        }}
      />
      <NavItem
        navItem={{
          path: `/g/${gSlug}/photo-series/ng`,
          title: "neknjižna građa",
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;
`;

export default GroupNavigationMob;
